<template>
  <custom-dialog
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    width="1200px"
    class="ship-select-device-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form :inline="true">
          <el-form-item style="float: right;">
            <search-input
              :placeholder="$t('crm_ship_selectDevice_dialog.ji_shen_hao')"
              @search="onSearch"
              v-model="formSearch.search"
            ></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          v-loading="isLoading"
          ref="table"
          height="400px"
          :data="tableList"
          tableCode="ship_device_select"
          type="radio"
          v-model="selectedRow"
        ></custom-table>
      </div>
      <!-- 分页 -->
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
      <el-button
        :disabled="!Object.keys(selectedRow).length"
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {},
  data() {
    return {
      isLoading: false,
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      selectedRow: [],
      tableList: [],
      totalRows: 0,
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onConfirm() {
      this.closeDialog();
      this.$emit('success', this.selectedRow);
    },
    closeDialog() {
      this.visible = false;
    },

    getTableList() {
      this.isLoading = true;
      this.$getJSON(apis.shipPlanDeviceSelect, this.formSearch).then((res) => {
        this.isLoading = false;
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    onSearch() {
      this.getTableList();
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;

      this.getTableList();
    },
  },
  created() {},
  mounted() {
    this.formSearch.productCode = this.model.productCode;
    this.formSearch.productSns = this.model.productSns;
    this.formSearch.deviceBizType = this.model.deviceBizType;
    this.getTableList();
  },
};
</script>

<style lang="scss" >

</style>
